import { useSyncExternalStore } from 'react';

/**
 * Whether the privacy notice (or the review prompt) is on screen. The help welcome card
 * waits while it is, so a newcomer meets one card at a time: the notice first, then the tour.
 */
let showing = false;
const listeners = new Set<() => void>();

export function setLegalNoticeShowing(next: boolean) {
  if (showing === next) return;
  showing = next;
  listeners.forEach((l) => l());
}

function subscribe(l: () => void) {
  listeners.add(l);
  return () => { listeners.delete(l); };
}

export function useLegalNoticeShowing(): boolean {
  return useSyncExternalStore(subscribe, () => showing, () => false);
}
